import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const SignalWifiStatusbarConnectedNoInternet4Icon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"signal_wifi_statusbar_connected_no_internet_4"} ref={ref}/>
});

SignalWifiStatusbarConnectedNoInternet4Icon.displayName = "SignalWifiStatusbarConnectedNoInternet4Icon";
